import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900">
      <div className="max-w-7xl mx-auto px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-5 cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/21854ded7812c3e1f6e0237d0c8099eb/b16dfe45d3df984f479dd6ea789b5412.png"
                  alt="恩誠國際 Logo"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div>
                <div className="font-bold text-white text-lg leading-tight">恩誠國際股份有限公司</div>
                <div className="text-gray-400 text-xs">En-Cheng International Co., Ltd.</div>
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-sm">
              專注於AI企業數位轉型服務，協助企業透過數據分析、客製化工具與AI自動化，提升效率與競爭力，邁向智慧化未來。
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-5 text-sm">聯絡資訊</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <i className="ri-map-pin-line text-teal-400 mt-0.5 flex-shrink-0"></i>
                <span>桃園市中壢區長安街78號</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-mail-line text-teal-400 flex-shrink-0"></i>
                <a href="mailto:enchengai.com@gmail.com" className="hover:text-teal-400 transition-colors cursor-pointer">enchengai.com@gmail.com</a>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-time-line text-teal-400 flex-shrink-0"></i>
                <span>週一至週五 09:00–18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © 2025 恩誠國際股份有限公司 En-Cheng International Co., Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}